const convertToNumber = (token) => token ? Number(token.replace('rem', '')) : undefined;
// calculating the reguired margin from top for notched variant label when it's centered
export const getInputLabelTransformStyle = (size, shrink, tokens) => {
    const inputTokens = tokens.uiElementInputFields;
    const sizeTokens = inputTokens[size === 'small' ? 'sizeSmall' : 'sizeMedium'];
    const elementHeight = convertToNumber(sizeTokens.height);
    const contentHeight = convertToNumber(sizeTokens.contentFontSize);
    const labelHeight = convertToNumber(sizeTokens.notchedLabelFontSize);
    if (elementHeight && contentHeight && labelHeight) {
        const marginTop = (elementHeight - contentHeight) / 2;
        const marginTopShrink = -(labelHeight / 2);
        if (shrink) {
            return {
                transform: `translate(${inputTokens.common.paddingLeft}px, ${marginTopShrink}rem) scale(1)`,
            };
        }
        // shrink = false, add style to [`&:not(.${inputLabelClasses.shrink})`] selector
        return {
            transform: `translate(${inputTokens.common.paddingLeft}px, ${marginTop}rem) scale(1)`,
        };
    }
    return {};
};
